// extracted by css-extract-rspack-plugin
export default {"sortDropdownButton":"SortingDropdown-module__sortDropdownButton__ooviD6f"};